module.exports = __webpack_public_path__ + "img/ourfacility.4ffcdb76.png";